import type { DummyFoods } from './dummyFoods'

export const lamb: DummyFoods = {
  Lamb: {
    Leg: {
      Cooked: ['Lamb leg (cooked)'],
      Raw: ['Lamb leg (raw)'],
    },
    Loin: {
      Cooked: ['Lamb loin (cooked)'],
      Raw: ['Lamb loin (raw)'],
    },
    Shoulder: {
      Cooked: ['Lamb shoulder (cooked)'],
      Raw: ['Lamb shoulder (raw)'],
    },
  },
}
